<template>
<div>
  <page-header :title="title"></page-header>
  <form @submit.prevent="gravar">
    <div class="modal-body">
      <div class="form-horizontal">
        <vue-element-loading :active="isActive" spinner="bar-fade-scale" color="#428BCA"></vue-element-loading>
		<div class="form-group">
			<select-form v-model="form.categoria_id" :value="form.categoria_id" name="Categoria"
				url="/categorias" id="id" titulo="title" layout="true" optionText="Selecione"
				required="true"></select-form>
		</div>
        <input-form-text textInput="Título" :required="true" v-model="form.title" :value="form.title"></input-form-text>
		<div class="form-group">
			<label class="col-sm-3 control-label no-padding-right" for="data"> Data</label>
			<div class="col-sm-3">
				<flat-pickr class="col-xs-10 col-sm-3 form-control" v-model="form.datecad" :config="config"
					placeholder="Data" name="date"></flat-pickr>
			</div>
		</div>
		<div class="form-group">
			<label class="col-sm-3 control-label no-padding-right"></label>
			<div class="col-sm-5">
				<items-edit :files="allImages" url="/galerias/upload" :capa="true"></items-edit>
				<file-upload ref="fupload" url="/galerias/upload" :id="null" :label="'PNG, JPG, GIF até 10 MB'" width="800"></file-upload>
			</div>
		</div>
        <div class="form-group">
          <select-form v-model="form.active" :value="form.active" name="Ativo" url="/arquivos" id="id" titulo="nome" layout="true" optionText="Selecione" required="true"></select-form>
        </div>
      </div>
    </div>
    <footer-button :disabled="isActiveBtn"></footer-button>
  </form>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.min.css'
import { Portuguese } from 'flatpickr/dist/l10n/pt.js'
import fileUpload from '@/components/form/file-upload/Index'
import ItemsEdit from '@/components/form/file-upload/ItemsEdit'
import moment from 'moment'

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
		flatPickr,
		fileUpload,
		ItemsEdit
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Galerias',
			form: {
				title: '',
				datecad: '',
				categoria_id: '',
				active: '1'
			},
			isActive: false,
			isActiveBtn: false,
			config: {
				wrap: true, // set wrap to true only when using 'input-group'
				altInput: true,
				// eslint-disable-next-line no-useless-escape
				altFormat: 'd \\de F \\de Y',
				dateFormat: 'Y-m-d',
				locale: Portuguese
			},
			allImages: [],
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		async gravar() {
			this.isActive = true
			this.isActiveBtn = true
			const body = this.form
			//this.setVersion()
			if (this.$route.params.id) {
				const resp = await req(`/galerias/${this.$route.params.id}`, 'put', body).catch(() => {
					erro()
				})
				this.isActive = false
				const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
				const m = tb[0]
				await m.uploadAll(resp)
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/sistema/galerias')
				
			} else {
				const resp = await req('/galerias', 'post', body).catch(() => {
					erro()
				})
				this.isActive = false
				const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
				const m = tb[0]
				await m.uploadAll(resp)
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/sistema/galerias')
			}
			this.isActiveBtn = false
		},
		async setVersion() {
			const dados = await req('/versao/1', 'put', {
				title: Date.now()
			})
			dados
		},
		async getDados() {
			const resp = await req(`/galerias/${this.$route.params.id}`).catch(() => {
				erro()
			})
			this.form.active = resp.active
			this.form.title = resp.title
			this.form.datecad = resp.datecad
			this.form.categoria_id = resp.categoria_id
			const images = await req(`/galerias/images/${this.$route.params.id}`).catch(() => {
				erro()
			})
			this.allImages = images
			this.isActive = false
		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	mounted() {
		this.form.datecad = moment(new Date()).format('YYYY-MM-DD')
		this.verifPermissao()
		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
